<template>
  <el-dialog title="" append-to-body :modal="false" :visible.sync="showLogin" width="90%" :close-on-click-modal="false" 
  custom-class="dialogBox" :before-close="dialogBeforeClose">
  <div class="loginBox">
    <div>
      <div class="titleText">Login</div>
      <el-form ref="form" :model="form" :rules="rules" label-width="0">
          <el-form-item label="" prop="userName">
            <el-input class="inputBox" v-model="form.userName" placeholder="Enter Your E-mail Address"></el-input>
          </el-form-item>
          <el-form-item label="" prop="password">
            <el-input class="inputBox" v-model="form.password" placeholder="Your Password" type="password"></el-input>
          </el-form-item>
      </el-form>
      <div class="forgotText" @click="showRecoverUser">Forgot Password?</div>
      <div class="loginBtn" @click="handleLogin">Login</div>
      <div class="createBox">
        <div>Don't have an account?</div>
        <div @click="goCreateUser">Create an Account</div>
      </div>
    </div>

  </div>
  <RecoverUser ref="RecoverUser"  @goLogin="show"/>
  <CreateUser ref="CreateUser" @showLogin="show"/>
  </el-dialog>
</template>

<script>
import RecoverUser from './RecoverUser.vue'
import CreateUser from './CreateUser.vue'
import { sm2 } from 'sm-crypto';
import { VITE_SM_PUBLIC_KEY } from '@/assets/js/conSysUrl'
import { login } from '@/api/user'

export default {
  components: {
    RecoverUser,
    CreateUser,
  },
  data() {
    return {
      showLogin: false,
      form: {
        userName: '',
        password: '',
      },
      rules: {
        userName: [
          { required: true, message: 'Please input the E-mail Address', trigger: 'blur' },
        ],
        password: [
          { required: true, message: 'Please input the password', trigger: 'blur' },
        ]

      }
    }
  },
  created() {
    this.$EventBus.$on('showLogin', this.show)
    document.addEventListener('keydown', this.handleKeyDown)
  },
  beforeDestroy() {
    document.removeEventListener('keydown', this.handleKeyDown)
  },
  methods: {
    handleKeyDown(e) {
      if (e.keyCode === 13) {
        this.handleLogin();
      }
    },
    goCreateUser() {
      this.dialogBeforeClose()
      this.$refs.CreateUser.show()
    },
    showRecoverUser() {
      this.dialogBeforeClose()
      this.$refs.RecoverUser.show()
    },
    dialogBeforeClose() {
      this.$refs.form.resetFields()
      this.$refs.form.clearValidate()
      this.showLogin = false
    },
    show() {
      this.showLogin = true
    },
    handleLogin() {
      this.$refs.form.validate((valid)  =>  {
        if (valid) {
          const publicKey = VITE_SM_PUBLIC_KEY;
          let msg = {
            userName: this.form.userName,
            password: sm2.doEncrypt(this.form.password, publicKey, 1),
            code: null,
            codeId: 0,
          }
          try {
            login(msg).then(res => {
            if (res.status) {
              this.$store.commit('setToken', res.data.token)
              this.$message.success('Login success')
              this.dialogBeforeClose()
              this.$store.dispatch('GetUserInfo')
            }
            else {
              this.$message.error('Login failed: Incorrect account or password.')
            }
            
            }).catch(err => {
              console.log(err);
            })
          } catch (error) {
            this.$message.error(error)
          }

        } else {
          return false;
        }
      });
    },

  }
}
</script>

<style lang="scss" scoped>
::v-deep{
  .dialogBox{
    min-width: 350px;
    max-width: 626px;
  }
  .el-dialog__body{
    padding: 10px;
  }
  .el-input__inner{
    border-radius: 10px;
    background: #f4f4f4;
  }
  .el-dialog__headerbtn{
    font-size: 30px;
    font-weight: 600;
  }
}

.loginBox{
  width: 100%;
  >div{
    margin: 0 auto;
    width: 300px;
    .titleText{
      color: #181818;
      font-size: 24px;
      font-weight: 600;
      text-align: center;
      margin-bottom: 20px;
    }
    .inputBox{
      // margin-top: 20px;
    }
    .forgotText{
      margin: 10px 0;
      font-size: 12px;
      color: #cbac92;
      text-align: end;
      cursor: pointer;
    }
    .loginBtn{
      user-select: none;
      margin: 0 auto;
      text-align: center;
      cursor: pointer;
      height: 50px;
      line-height: 50px;
      background-color: #000;
      font-weight: 600;
      color: #fff;
    }
    .loginBtn:hover{
     background: #cbac92;
     color: #000;
    }
    .createBox{
      margin: 30px 0;
      text-align: center;
      font-size: 14px;
      >div:nth-child(2){
        cursor: pointer;
        color: #cbac92;
      }
    }
  }


}



</style>